import React from 'react';
import PropTypes from 'prop-types';
import UserManagementStore from '../../stores/UserManagementStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Field } from 'web-ui-components/lib/molecules/forms';

const NoAccountPoolExist = ({
  content: { noAccountPoolExist, createFirstAccountPool },
}) => (
  <Field className="web-ui-components">
    <Card>
      <StandardBody>
        <p>{noAccountPoolExist}</p>
        {UserManagementStore.isCorporateAdmin() && (
          <Button
            width="wide"
            display="primary"
            onClick={() =>
              InternetBankingActions.navigateToWebTask('WEB-CREATE-POOL')
            }
          >
            {createFirstAccountPool}
          </Button>
        )}
      </StandardBody>
    </Card>
  </Field>
);

NoAccountPoolExist.propTypes = {
  content: PropTypes.object,
};

export { NoAccountPoolExist };
